module.exports = "<div class=\"map-visualization-container\">\n  <div resize-event=\"handleResize()\"></div>\n</div>\n"